import {Controller} from "@hotwired/stimulus";
import Clipboard from "clipboard";
import {useModal} from "../../js/stimulus_use/use-modal";
import $ from "jquery";
import * as moment from "moment";


/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'share',
        'litigant--choose-or-create',
        'document--create-modal',
        'document--create-or-upload'
    ];

    static values = {
        litigantName: String,
        litigantId: Number,
        source: String,
        isViewed: Boolean,
        isGuideShown: Boolean,
    };

    static targets = [
        'bookingDocumentHtml',
        'litigantNameInput',
        'dataStep',
        'litigantName',
        'guide',
        'icon',
        'dontShowInput',
        'litigant',
        'form',
        'descriptionInput',
        'amountInput',
        'messageInput',
        'documentHasVatInput',
        'litigantId',
    ];

    dontShowAgainUrl = routes['app_document_feeagreementguidepopupdontshow'];
    viewedUrl = routes['app_document_setfeeagreementmodalasviewedat'];
    litigantName = '';

    connect() {
        useModal(this, {
            withGuide: true,
            withViewed: true,
            withLitigant: true,
        });
    }

    onOpen() {
        this.documentCreateModalOutlet.openingModalController = this;
        this.clearForm();
        this.showLitigantOrForm();
    }

    onHide() {
        this.hideForm();
        this.hideLitigant();
        this.clearForm();
    }

    showLitigantOrForm() {
        if (this.litigantIdValue) {
            this.showDataStep();
        } else {
            this.hideDataStep()
            this.hideForm();
            this.showLitigant();
        }
    }

    litigantChosenOrCreated() {
        this.hideLitigant();
        this.showDataStep();
    }

    inputFieldEditToggle() {
        if (this.litigantNameInputTarget.disabled === true) {
            this.litigantNameInputTarget.disabled = false;
        } else {
            this.litigantNameInputTarget.disabled = true;
        }
    }

    showDataStep() {
        this.litigantIdTarget.value = this.litigantIdValue ? this.litigantIdValue : this.litigantChooseOrCreateOutlet.getData().litigant_id;
        this.documentCreateModalOutlet.openingModalController = this;

        if (this.litigantChooseOrCreateOutlet.getName() !== null) {
            this.litigantName = this.litigantChooseOrCreateOutlet.getName();
        } else {
            this.litigantName = this.litigantNameValue;
        }

        this.litigantNameInputTarget.value = this.litigantName;
        this.dataStepTarget.style.removeProperty('display');
        this.hideLitigant();
        this.hideForm();
    }

    showDataPreviewStep() {
        this.dataStepTarget.style.setProperty('display', 'none');
        this.formTarget.style.removeProperty('display');

        $(".litigant-name").text(this.litigantName);
    }

    hideDataStep(event) {
        event && event.preventDefault();

        this.dataStepTarget.style.setProperty('display', 'none');
    }

    createDocumentTemplate(event) {
        event.preventDefault();
        showPreloader();

        let data = this.getDataForCreateDocumentModal();

        if (!data) {
            hidePreloader();
            return;
        }

        $.ajax({
            url: routes['app_document_feedocumentcreate'],
            type: 'POST',
            data: data,
            success: (response) => {
                if (response.status) {
                    this.hide();
                    this.documentCreateModalOutlet.open(response.template);
                } else {
                    hidePreloader();
                    addAlert('danger', response.message);
                }
            },
            error: () => {
                hidePreloader();
                addAlert('danger', translations['profile.An unknown error occurred.']);
            }
        }).done(() => {
            hidePreloader();
        });
    }

    showForm() {
        this.documentCreateModalOutlet.openingModalController = this;

        if (this.createAndUploadDocumentAvailableValue) {
            this.documentCreateOrUploadOutlet.containerController = this;
        }

        if (this.litigantChooseOrCreateOutlet.getName() !== null) {
            $(this.litigantNameTarget).text(this.litigantChooseOrCreateOutlet.getName());
        } else {
            $(this.litigantNameTarget).text(this.litigantNameValue);
        }

        this.formTarget.style.removeProperty('display');
    }

    hideForm(event) {
        event && event.preventDefault();

        this.formTarget.style.setProperty('display', 'none');
    }

    clearForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();
        this.litigantChooseOrCreateOutlet.clear();
        this.litigantNameInputTarget.disabled = true;
        this.descriptionInputTarget.value = '';
        this.amountInputTarget.value = '';
        this.messageInputTarget.value = '';
        this.bookingDocumentHtmlTarget.value = '';
        this.documentHasVatInputTarget.checked = false
    }

    clearFormErrors() {
        this.litigantChooseOrCreateOutlet.clearErrors();

        this.formTarget.querySelectorAll('.is-invalid').forEach((element) => {
            element.classList.remove('is-invalid');
        });
    }

    submitForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();

        if (!this.bookingDocumentHtmlTarget.value) {
            this.bookingDocumentHtmlTarget.classList.add('is-invalid');
            return;
        }

        showPreloader();

        const formData = new FormData();
        formData.append('source', this.sourceValue);
        formData.append('message', this.messageInputTarget.value);

        if (this.litigantIdValue) {
            formData.append('litigant_id', this.litigantIdValue)
        } else {
            const litigantData = this.litigantChooseOrCreateOutlet.getData();

            // foreach property of litigant data add to form data
            for (const [key, value] of Object.entries(litigantData)) {
                formData.append(key, value);
            }
        }

        formData.append('document_html', this.bookingDocumentHtmlTarget.value);

        $.ajax({
            url: routes['app_document_directfeeagreementcreate'],
            data: formData,
            type: 'post',
            contentType: false,
            processData: false,
            success: (response) => {
                if (!response.status) {
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);
                    return;
                }

                if (window.location.href === response.chat_url) {
                    location.reload()
                } else {
                    window.location.href = response.chat_url;
                }
            }
        }).fail(() => {
            hidePreloader();
            addAlert('danger', translations['profile.An unknown error occurred.']);
        });
    }

    getDataForCreateDocumentModal() {
        let validData = true;

        if (this.descriptionInputTarget && this.descriptionInputTarget.value) {
            this.descriptionInputTarget.classList.remove('is-invalid');
        } else {
            this.descriptionInputTarget.classList.add('is-invalid');
            validData = false;
        }

        if (this.amountInputTarget.value) {
            this.amountInputTarget.classList.remove('is-invalid');
        } else {
            this.amountInputTarget.classList.add('is-invalid');
            validData = false;
        }

        if (this.litigantNameInputTarget.value) {
            this.litigantNameInputTarget.classList.remove('is-invalid');
        } else {
            this.litigantNameInputTarget.classList.add('is-invalid');
            validData = false;
        }

        if (!validData) {
            return;
        }

        let data = {
            description: this.descriptionInputTarget.value,
            amount: this.amountInputTarget.value,
            vat: this.documentHasVatInputTarget.checked,
            changed_litigant_name: this.litigantNameInputTarget ? this.litigantNameInputTarget.value : null,
        };

        if (this.litigantIdValue) {
            data.litigant_id = this.litigantIdValue;
        } else {
            data = {
                ...data,
                ...this.litigantChooseOrCreateOutlet.getData(),
            };
        }

        return data;
    }

    documentEdit() {
        this.hide();

        this.documentCreateModalOutlet.open($(this.bookingDocumentHtmlTarget).val());
    }
}
